export const getMediaChipMap = (responses) => {
  let videoCount = 0;
  let imageCount = 0;
  let documentCount = 0;
  const mediaLabelData = {};
  responses?.forEach((response) => {
    if (response?.mediaId) {
      videoCount++;
      mediaLabelData[response?.mediaId] = `${response?.type} ${videoCount}`;
    } else if (response?.attachmentId) {
      response?.type == 'IMAGE' ? imageCount++ : documentCount++;
      mediaLabelData[response?.attachmentId] = `${response?.type} ${
        response?.type == 'IMAGE' ? imageCount : documentCount
      }`;
    }
  });
  return mediaLabelData;
};



// WEBPACK FOOTER //
// ./src/utils/getMediaChipMap.js